import {getImageUrl} from '@cohort/shared/utils/media';
import {FastAverageColor} from 'fast-average-color';
import {useEffect, useState} from 'react';

export const useRemoteImageDominantColor = (imageUrl: string | null): string | undefined => {
  const [color, setColor] = useState<string | undefined>(undefined);

  useEffect(() => {
    async function getRemoteImageColor(url: string): Promise<void> {
      const fac = new FastAverageColor();
      const dominantColor = await fac.getColorAsync(getImageUrl(import.meta.env.COHORT_ENV, url));

      setColor(dominantColor.hex);
    }

    if (imageUrl !== null) {
      getRemoteImageColor(imageUrl);
    }
  }, [imageUrl]);

  return color;
};
